import { forwardRef } from 'react';

import { ToDoList } from '@crehana/compass.dashlets/to-do-list';

import { useGetTodoList } from '../hooks/use-get-to-do-list';

type TToDoListProps = {
  talentUrl: string;
  isProduction: boolean;
};

const ToDoListWidget = forwardRef<HTMLDivElement, TToDoListProps>(
  ({ talentUrl, isProduction }, ref: React.ForwardedRef<HTMLDivElement>) => {
    const {
      loading: loadingToDoList,
      dataTodoList,
      error: errorToDoList,
      refetch: retryToDoList,
    } = useGetTodoList();

    return (
      <div ref={ref} className="tw-w-full tw-h-full">
        <ToDoList
          isLoading={loadingToDoList}
          toDoList={dataTodoList}
          isError={!!errorToDoList}
          retry={retryToDoList}
          isProduction={isProduction}
          talentUrl={talentUrl}
        />
      </div>
    );
  },
);

ToDoListWidget.displayName = 'ToDoListWidget';

export { ToDoListWidget };
